
import EstimatedExchangeRate from "@/store/modules/system/estimatedexchangerate/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins } from "@/lib";
@Component({})
export default class CreateEstimatedExchangeRate extends Mixins(FormModalMixins) {
  model: EstimatedExchangeRate = new EstimatedExchangeRate();
  created() {
    Object.assign(this.config, { modelTitleL: "Action.Add", labelWidth: 200, okAction: "system/estimatedexchangerate/create" });
  }

  mounted() {
    // (this.$refs["form-modal"] as any).resetFields();
  }
}
